import React from "react";

const Profile = () => {
  return (
    <div className="bg-white p-4 flex flex-col rounded-[10px]">
      <h2 className="font-semibold font-lexend sm:text-lg text-xl">
        Personal Information
      </h2>
      <form action="" className="sm:text-sm text-lg">
        <input
          type="text"
          placeholder="First Name *"
          className="w-full border border-[#b1b1b1] rounded-[10px] sm:py-2 py-3 px-4 mt-4 placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]"
        />
        <input
          type="email"
          placeholder="Email Address *"
          className="w-full border border-[#b1b1b1] rounded-[10px] sm:py-2  py-3 px-4 mt-4 placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]"
        />
        <input
          type="text"
          placeholder="Phone *"
          className="w-full border border-[#b1b1b1] rounded-[10px] sm:py-2  py-3 px-4 mt-4 placeholder:font-lexend font-lexend outline-none focus:border-[#2a552f]"
        />
        <div className="flex justify-end">
          <button className="bg-[#2a552f] font-semibold text-[#f4e390] sm:text-base  text-xl font-lexend sm:py-2 py-2.5 px-11 rounded-lg sm:mt-4 mt-6">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default Profile;
